import React, { useRef } from "react";
import { Trans, useTranslation } from "react-i18next";
import styles from "./AttestText.module.css";
import enabledMap from "../../../translations/en/enotif.json";
import disabledMap from "../../../translations/en/enotifdisabled.json";
import AmpCheckBox from "../../common/AmpCheckBox/AmpCheckBox";
import AmpButton from "../../common/AmpButton/AmpButton";

export interface AttestTextProps {
    isEnabled: boolean;
    handleConsent: (checked: boolean) => void;
}

export default function AttestText(props: AttestTextProps) {

    const { t } = useTranslation(["enotif", "enotifdisabled", "login"])
    const ns = props.isEnabled ? "enotif" : "enotifdisabled";


    const ref = useRef<HTMLInputElement>(null);

    const buildTerm = () => {
        const config: Record<string, unknown> = !props.isEnabled ? disabledMap : enabledMap;
        const keys = Object.keys(config).filter((v) => v.includes("paragraph"));
        const list = keys.map((paragraph: string, index: number) => {
            const subkeys = Object.keys(config[paragraph] as JSON).filter((k) => !k.includes("heading"))
            return (
                <li key={index}>
                    <strong>{t(`${paragraph}.heading`, { ns: ns })}</strong>
                    <ol>
                        {subkeys.map((subsection: string, index: number) => {
                            return (
                                <li key={`sub${index}`}>
                                    <Trans defaults={t(`${paragraph}.${subsection}`, { ns: ns })}>
                                        {/* eslint-disable-next-line */}
                                        <a className="amp-anchor blue" target="_blank" rel="noopener noreferrer"></a>
                                        <sup></sup>
                                    </Trans>
                                </li>
                            )
                        })}
                    </ol>
                </li>
            )
        })
        return list;
    }

    const setChecked = (e: React.MouseEvent<Element, MouseEvent>) => {
        e.preventDefault();
        e.stopPropagation();
        if (ref.current) {
            ref.current.checked = true;
        }
        props.handleConsent(true);
    }

    return (<div>
        <h2>{t("heading", { ns: ns })}</h2>

        
        <p>
            <Trans defaults={t("top-text", { ns: ns })}>
                {/* eslint-disable-next-line */}
                <sup></sup>
            </Trans>
        </p>
        <div className={styles.Scrollable}>

            <ol>
                {buildTerm()}
            </ol>
        </div>
        <h3>{t("bottom-heading", { ns: ns })}</h3>
        <div className={styles.BottomConsent}>
            <p>
                {t("bottom-text", { ns: ns })}
            </p>
            <div className={styles.Agree}>
                <AmpCheckBox
                    blueStyle={true}
                    handleCheck={(e) => { props.handleConsent((e.target as HTMLInputElement).checked) }}
                    id={""}
                    label={""}
                    hasToolTip={false}
                    toolTip={""}
                    ref={ref}

                />
                <AmpButton
                    onClick={(e) => setChecked(e)}
                    type={"submit"}
                    text={t("agree", { ns: "login" })}
                    atlStyle />
            </div>

        </div>

    </div>
    );
}